export const FETCH_JOURNAL_PAGE_REQUESTED = 'JOURNAL/FETCH_JOURNAL_PAGE_REQUESTED';
export const FETCH_JOURNAL_PAGE_SUCCESS = 'JOURNAL/FETCH_JOURNAL_PAGE_SUCCESS';

export const FETCH_JOURNAL_FAVORITE_REQUESTED = 'JOURNAL/FETCH_JOURNAL_FAVORITE_REQUESTED';
export const FETCH_JOURNAL_FAVORITE_SUCCESS = 'JOURNAL/FETCH_JOURNAL_FAVORITE_SUCCESS';

export const FETCH_JOURNAL_TAG_REQUESTED = 'JOURNAL/FETCH_JOURNAL_TAG_REQUESTED';
export const FETCH_JOURNAL_TAG_SUCCESS = 'JOURNAL/FETCH_JOURNAL_TAG_SUCCESS';

export const FILTER_JOURNAL_SUCCESS = 'JOURNAL/FILTER_JOURNAL_SUCCESS';
export const SORT_JOURNAL_SUCCESS = 'JOURNAL/SORT_JOURNAL_SUCCESS';

export const CREATE_JOURNAL_TAG_REQUESTED = 'JOURNAL/CREATE_JOURNAL_TAG_REQUESTED';
export const CREATE_JOURNAL_TAG_SUCCESS = 'JOURNAL/CREATE_JOURNAL_TAG_SUCCESS';

export const UPDATE_JOURNAL_TAG_REQUESTED = 'JOURNAL/UPDATE_JOURNAL_TAG_REQUESTED';
export const UPDATE_JOURNAL_TAG_SUCCESS = 'JOURNAL/UPDATE_JOURNAL_TAG_SUCCESS';

export const DELETE_JOURNAL_TAG_REQUESTED = 'JOURNAL/DELETE_JOURNAL_TAG_REQUESTED';
export const DELETE_JOURNAL_TAG_SUCCESS = 'JOURNAL/DELETE_JOURNAL_TAG_SUCCESS';

export const ATTACH_JOURNAL_TAG_REQUESTED = 'JOURNAL/ATTACH_JOURNAL_TAG_REQUESTED';
export const ATTACH_JOURNAL_TAG_SUCCESS = 'JOURNAL/ATTACH_JOURNAL_TAG_SUCCESS';

export const DETACH_JOURNAL_TAG_REQUESTED = 'JOURNAL/DETACH_JOURNAL_TAG_REQUESTED';
export const DETACH_JOURNAL_TAG_SUCCESS = 'JOURNAL/DETACH_JOURNAL_TAG_SUCCESS';

export const DELETE_JOURNAL_ENTRY_REQUESTED = 'JOURNAL/DELETE_JOURNAL_ENTRY_REQUESTED';
export const DELETE_JOURNAL_ENTRY_SUCCESS = 'JOURNAL/DELETE_JOURNAL_ENTRY_SUCCESS';
export const DELETE_JOURNAL_ENTRY_FAILURE = 'JOURNAL/DELETE_JOURNAL_ENTRY_FAILURE';
